import {cloneDeep, find} from 'lodash'
import constants from '@/libs/constant/constants'
import {message, errorHandler, logout, loader, urlValidation} from '@/libs/helper'
import {bulkUpdate} from '@/libs/api/api'

export default{
    name: 'SocialMediaForm',
    props:{
        claimTo: {
            type: Object,
            default: () => {}
        },
        setClaimTo:{
            type: Function,
            default: ()=>{}
        },
        disabled: {
            type: Boolean,
            default: ()=> false
        },
        isEdit: {
            type: Boolean,
            default: ()=> false
        },
        module: {
            type: String,
            default: () => constants.AUTHOR.key
        },
        isAdmin: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        claimTo(value) {
            this.addedPlatform = value.social_media
            this.selectedPlatform = value.social_media
        }
    },
    data() {
        return {
            platforms: [{type:'FACEBOOK', url: ''},{type:'LINKEDIN', url: ''},{type:'TWITTER', url: ''}, {type: 'PARLER', url: ''}],
            addedPlatform: this.claimTo && this.claimTo.social_media || [],
            selectedPlatform: this.claimTo && this.claimTo.social_media || []
        }
    },
    methods: {
        isDisabled (platform) {
            let socialPlatform = this.claimTo.social_media
            return find(socialPlatform, platform) ? true : false
        },
        isChecked (platform) {
            let addedPlatform = this.selectedPlatform
            return addedPlatform.filter(p => p.type === platform.type).length > 0
        },

        editSocialPlatform(module, platform, index, isRemove){

            if(!isRemove && !this.socialMediaUrlValidation(platform)){
                message(this, constants.messageType.ERROR, `Please enter valid ${platform.type.toLowerCase()} url`)
                return
            }

            loader(this, true);
            let addedPlatform = cloneDeep(this.addedPlatform)
            if(isRemove){
                addedPlatform = addedPlatform.filter(pf => pf.type !== platform.type)
            } else {
                addedPlatform[index] = platform
            }

            addedPlatform.map((p, index) => {
                if(p._id){
                    delete addedPlatform[index]._id
                }
                delete addedPlatform[index].createdAt
                delete addedPlatform[index].updatedAt
            })

            if(module === constants.AUTHOR.key){
                bulkUpdate(constants.AUTHOR.key.toLowerCase(), {social_media: addedPlatform, entity_ids: [this.claimTo._id]})
                    .then(()=> {
                        this.addedPlatform = addedPlatform
                        if(isRemove){
                            this.selectedPlatform = this.selectedPlatform.filter(p => p.type !== platform.type)
                        }
                        message(this, constants.messageType.SUCCESS, 'Updated Successfully');
                        let claimTo = cloneDeep(this.claimTo)
                        claimTo.social_media = cloneDeep(this.addedPlatform)
                        this.$emit('updateSocialMedia', claimTo)
                        this.setClaimTo(this.module)
                        loader(this, false);
                    })
                    .catch((error)=> {
                        message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                        loader(this, false);
                    })
            }else if(module === constants.PUBLISHER.key){
                bulkUpdate(constants.PUBLISHER.key.toLowerCase(), {social_media: addedPlatform, entity_ids: [this.claimTo._id]})
                    .then(()=> { 
                        this.addedPlatform = addedPlatform
                        if(isRemove){
                            this.selectedPlatform = this.selectedPlatform.filter(p => p.type !== platform.type)
                        }
                        message(this, constants.messageType.SUCCESS, 'Updated Successfully');
                        let claimTo = cloneDeep(this.claimTo)
                        claimTo.social_media = cloneDeep(this.addedPlatform)
                        this.$emit('updateSocialMedia', claimTo)
                        this.setClaimTo(this.module)   
                        loader(this, false);
                    })
                    .catch((error)=> {
                        message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                        loader(this, false);
                    })
                }else if(module === constants.PUBLICATION.key){

                bulkUpdate(constants.PUBLICATION.key.toLowerCase(), {social_media: addedPlatform, entity_ids: [this.claimTo._id]})
                    .then(()=> {
                        this.addedPlatform = addedPlatform
                        if(isRemove){
                            this.selectedPlatform = this.selectedPlatform.filter(p => p.type !== platform.type)
                        }
                        message(this, constants.messageType.SUCCESS, 'Updated Successfully');
                        let claimTo = cloneDeep(this.claimTo)
                        claimTo.social_media = cloneDeep(this.addedPlatform)
                        this.$emit('updateSocialMedia', claimTo)
                        this.setClaimTo(this.module)
                        loader(this, false);
                    })
                    .catch((error)=> {
                        message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                        loader(this, false);
                    })
            }
        },

        updateSocialPlatform(platform, index, isRemove){

            if(!isRemove && !this.socialMediaUrlValidation(platform)){
                message(this, constants.messageType.ERROR, `Please enter valid ${platform.type.toLowerCase()} url`)
                return
            }

            let addedPlatform = cloneDeep(this.addedPlatform)

            if(isRemove){
                addedPlatform = addedPlatform.filter(pf => pf.type !== platform.type)
            } else {
                addedPlatform[index] = platform
            }
            this.addedPlatform = addedPlatform

            let claimTo = this.claimTo
            claimTo.social_media = this.addedPlatform
            this.selectedPlatform = claimTo.social_media
        },
        selectPlatformToAdd(plateform){
            let selectedPlatform = cloneDeep(this.selectedPlatform)
            if (find(selectedPlatform, plateform)) {
                selectedPlatform = selectedPlatform.filter(f => f.type !== plateform.type)
            } else {
                selectedPlatform.push(plateform)
            }
            this.selectedPlatform = cloneDeep(selectedPlatform)
        },
        addPlatform(){
            // if(isEmpty(this.addedPlatform)){
                this.addedPlatform = this.selectedPlatform
            // }else{
            //     console.log(this.addedPlatform, this.selectedPlatform)
            //     this.addedPlatform = sortBy(uniqBy(this.addedPlatform.concat(this.selectedPlatform), 'type'), 'type')
            // }
        },
        socialMediaUrlValidation(platform){
            if(platform.type.toLowerCase() === 'facebook' && (!urlValidation(platform.url) || !platform.url.match(/facebook.com/g))){
                return false
            }

            if(platform.type.toLowerCase() === 'linkedin' && (!urlValidation(platform.url) || !platform.url.match(/linkedin.com/g))){
                return false
            }

            if(platform.type.toLowerCase() === 'twitter' && (!urlValidation(platform.url) || !platform.url.match(/http(?:s)?:\/\/(?:www\.)?twitter\.com\/([a-zA-Z0-9_]+)/g))){
                return false
            }

            if(platform.type.toLowerCase() === 'parler' && (!urlValidation(platform.url) || !platform.url.match(/http(?:s)?:\/\/(?:www\.)?parler\.com\/([a-zA-Z0-9_]+)/g))){
                return false
            }

            return true
        },
    }
}